import { StyledTable } from './styles';

export default StyledTable;
